import React from 'react';
import classNames from 'classnames';
import { ChevronRight } from '@johnlewispartnership/wtr-ingredients/dist/foundations/icons';
import { urls } from 'constants/urls';

import styles from './ShopByList.module.scss';

export interface ShopByListCtaProps {
  hidden?: boolean;
  onClick?: () => void;
  searchbox?: boolean;
}

export const ShopByList = ({ hidden = false, onClick, searchbox = false }: ShopByListCtaProps) => {
  if (hidden) {
    return null;
  }

  return (
    <>
      <a
        className={classNames(styles.cta, {
          [styles.searchboxCta]: searchbox,
        })}
        onClick={onClick}
        href={urls.shopByList}
      >
        Shop by list
      </a>
      {!searchbox && <ChevronRight size="xsmall" className={styles.chevronRightIcon} />}
    </>
  );
};
